class Documento {
    constructor(
        {
            id = null,
            nome_original = null,
            nome_minio = null,
            hash_arquivo = null,
            extensao = null,
            mimetype = null,
            size = null,
            codigo_assinatura_digital = null,
            dt_criacao = null,
            dt_atualizacao = null,
            prefix = null
        } = {}
    ) {
        this.id = id; 
        this.nome_original = nome_original; 
        this.nome_minio = nome_minio; 
        this.hash_arquivo = hash_arquivo; 
        this.extensao = extensao;
        this.mimetype = mimetype; 
        this.size = size;
        this.codigo_assinatura_digital = codigo_assinatura_digital; 
        this.dt_criacao = dt_criacao; 
        this.dt_atualizacao = dt_atualizacao;
        this.prefix = prefix;
    }
}

export default Documento;